{
  "myData.delete.section.heading": "Radera konto",
  "myData.delete.section.description": "Du kan permanent radera ditt konto och de personuppgifter som är kopplade till det. Åtgärden kan inte ångras.",
  "myData.delete.trigger": "Radera konto",
  "myData.delete.title": "Radera konto",
  "myData.delete.irreversible": "Att radera kontot är permanent och kan inte ångras. Dina uppgifter raderas omedelbart och det finns ingen ångerfrist.",
  "myData.delete.retainedNote": "Uppgifter som vi enligt lag måste bevara sparas utan din personliga identitet.",
  "myData.delete.confirm": "Radera kontot permanent",
  "myData.delete.cancel": "Avbryt",
  "myData.delete.pending": "Raderar…",
  "myData.delete.done": "Ditt konto har raderats.",
  "myData.delete.doneClose": "Stäng",
  "myData.delete.unavailable": "Det går ännu inte att radera kontot.",
  "myData.delete.error": "Det gick inte att radera kontot. Försök igen."
}
